/* eslint-disable no-undef */
export default {
	name: "logs-table",
	props: ["heartbeatStatusCodeId"],
	data() {
		return {
			heartbeatLogs: [],
			loading: false,
			pageNumber: 1,
			pageSize: 100
		};
	},
	methods: {
		getHeartbeats(){
			this.loading = true;
			heartbeatService.getHeartbeats(this.pageNumber, this.pageSize, this.heartbeatStatusCodeId).then(
				successResponse => {
					var isSuccessResponse = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpResponseCode, 
						"Something went wrong while attempting to get heartbeats");
					if(isSuccessResponse){
						this.heartbeatLogs = successResponse.data.result;
					}
					this.loading = false;
				},
				errorResponse => {
					//error
					this.loading = false;
					console.log("error", errorResponse);
					alert("Unexpected error occurred");
				}
			);
		}
	},
	mounted: function () {
		
	},
	watch:{
		heartbeatStatusCodeId:{
			handler: function()
			{
				this.getHeartbeats();
			},
			immediate: true,
			deep: true
		}
	}
};